import React from 'react'
import {Controller} from 'react-hook-form'
import SettingsPanel from 'organization/Event/DashboardConfig/ComponentConfigPanel/SettingsPanel'
import StylingPanel from 'organization/Event/DashboardConfig/ComponentConfigPanel/StylingPanel'
import Settings from 'Event/EventOfflinePage/OfflineContentConfig/Settings'
import {useSaveTemplate} from 'Event/TemplateUpdateProvider'
import {useConfig} from 'organization/Event/Configurable'
import Config from 'organization/Event/Configurable/Config'
import {useAddTranslation} from 'Event/LanguageProvider'
import {replaceAtPath} from 'lib/JsonUpdateProvider'
import ColorPicker from 'lib/ui/ColorPicker'
import Slider from 'lib/ui/Slider'
import {useSimpleBlogTemplate} from 'Event/template/SimpleBlog'

export default function OfflineContentConfig() {
  const saveTemplate = useSaveTemplate()
  const addTranslation = useAddTranslation()
  const {offlinePage, login, textColor} = useSimpleBlogTemplate()
  const titleTextColor =
    offlinePage.titleTextColor || login.description.color || textColor
  const {
    form: {control, register},
  } = useConfig()

  const save = (data: any) => {
    const description = replaceAtPath(
      data,
      'offlinePage.description',
      '{{offline_page_description}}',
    )
    const title = replaceAtPath(
      data,
      'offlinePage.title',
      '{{offline_page_title}}',
    )
    saveTemplate({
      ...data,
      localization: addTranslation({
        offline_page_description: description ?? '',
        offline_page_title: title ?? '',
      }),
    })
  }

  return (
    <Config title="Event Offline Page" onSave={save}>
      <SettingsPanel>
        <Settings control={control} register={register} />
      </SettingsPanel>
      <StylingPanel>
        <Controller
          name="offlinePage.titleTextColor"
          defaultValue={titleTextColor}
          control={control}
          render={({value, onChange}) => (
            <ColorPicker
              label="Title Text Color"
              color={value}
              onPick={onChange}
              aria-label="offline page title text color"
            />
          )}
        />
        <Controller
          name="offlinePage.titleFontSize"
          defaultValue={offlinePage.titleFontSize ?? 24}
          control={control}
          render={({value, onChange}) => (
            <Slider
              valueLabelDisplay="auto"
              aria-label="offline page title font size"
              value={value}
              onChange={onChange}
              step={1}
              min={5}
              max={50}
              label="Title Font Size"
            />
          )}
        />
      </StylingPanel>
    </Config>
  )
}
